// Pure saved-clock readers shared by status tools and perception. No compile or scene dependencies.
export const STATUS_TIME_UNITS = ['year', 'month', 'day', 'hour', 'minute', 'second'] as const;

export function statusTimeValueNonZero(value: unknown): boolean {
  const v = Array.isArray(value) ? value[0] : value;
  return v !== undefined && v !== null && v !== '' && !(Number.isFinite(Number(v)) && Number(v) === 0);
}

/** status_instance_has_campaign_pause(): any non-zero saved pause-clock component. */
export const statusIsPaused = (entry: Record<string, unknown>): boolean =>
  STATUS_TIME_UNITS.some(unit => statusTimeValueNonZero(entry['status_paused_campaign_' + unit]));
